import { Checkbox, MessageBar, MessageBarBody } from '@fluentui/react-components';
import { AttachRegular } from '@fluentui/react-icons';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AssignmentResourceItem } from '../../../../Assignments';
import { Button } from '../../../../Button';
import { Input } from '../../../../Input';
import { CommonHomeworkForm } from './CommonHomeworkForm';
import {
  FileWithAssignmentResourceItemProps,
  SelectTeamsAssignmentWithResources,
} from './NewHomeworkDialog.interfaces';
import './TeamsHomeworkView.scss';

export interface TeamsHomeworkViewProps {
  editable: boolean;
  selectedHomework?: SelectTeamsAssignmentWithResources;
  filePickerResources?: FileWithAssignmentResourceItemProps[];
  selectedHomeworkChanged?: (homework: SelectTeamsAssignmentWithResources) => void;
  onSetFilePickerResources: (filePickerResources: FileWithAssignmentResourceItemProps[]) => void;
  createAsTeamsAssignmentUnchecked: () => void;
  openFilePickerClicked: () => void;
  selectedDate: Date;
}

export const TeamsHomeworkView: FC<TeamsHomeworkViewProps> = (props) => {
  const {
    selectedHomework,
    editable,
    filePickerResources,
    createAsTeamsAssignmentUnchecked,
    selectedHomeworkChanged,
    onSetFilePickerResources,
    openFilePickerClicked,
    selectedDate,
  } = props;
  const { t } = useTranslation();
  const selectedFilePickerResources =
    filePickerResources?.map((resource, index) => {
      const associatedHomeworkResource = selectedHomework?.resources.find(
        (homeworkResource) => homeworkResource.id === resource.file.id,
      );
      return (
        <li key={index}>
          <AssignmentResourceItem
            displayName={associatedHomeworkResource?.displayName ?? resource.displayName}
            distributeForStudentWork={
              associatedHomeworkResource?.distributeForStudentWork ??
              resource.distributeForStudentWork
            }
            id={associatedHomeworkResource?.id ?? resource.file.id ?? resource.id}
            distributeHidden={
              associatedHomeworkResource?.distributeHidden ?? resource.distributeHidden
            }
            handleDistributeChange={
              associatedHomeworkResource?.handleDistributeChange ?? resource.handleDistributeChange
            }
            handleDownload={associatedHomeworkResource?.handleDownload ?? resource.handleDownload}
            handleOpen={associatedHomeworkResource?.handleOpen ?? resource.handleOpen}
            isLink={associatedHomeworkResource?.isLink ?? resource.isLink}
            editMode={editable}
            handleDeleteResource={() =>
              onSetFilePickerResources([
                ...(filePickerResources?.filter((item) => item.file !== resource.file) ?? []),
              ])
            }
          />
        </li>
      );
    }) ?? [];
  return (
    <div className="flex flex-col teamsHomeworkView">
      <Checkbox
        label={t('classbook:newassignment:dialog_create_teams', {
          defaultValue: 'Als Teams-Aufgabe anlegen',
        })}
        checked
        onChange={createAsTeamsAssignmentUnchecked}
        className="input"
      />
      <CommonHomeworkForm
        selectedHomework={selectedHomework}
        selectedHomeworkChanged={selectedHomeworkChanged}
        minDate={selectedDate}
      />
      <span className="inputLabel">
        {t('classbook:newassignment:dialog_points', { defaultValue: 'Punkte' })}
      </span>
      <Input
        appearance="filled-darker"
        className="inputNumber inputPoints w-full"
        type="number"
        min={0}
        max={100}
        value={String(selectedHomework?.assignmentPoints ?? 0)}
        onChange={(_, points) => {
          selectedHomework
            ? selectedHomeworkChanged?.({
                ...selectedHomework,
                assignmentPoints: points?.value ?? '',
              })
            : null;
        }}
      />
      <MessageBar intent="warning" className="resourceAlert">
        <MessageBarBody>
          {t('assignment_ressource_warning', {
            defaultValue: 'Es können maximal 10 Anhänge hinzugefügt werden.',
          })}
        </MessageBarBody>
      </MessageBar>

      <div className="flex flex-col items-start">
        <Button
          icon={<AttachRegular />}
          className="resourceBtn"
          appearance="transparent"
          onClick={() => openFilePickerClicked()}
        >
          {t('assignment_ressources', { defaultValue: 'Ressourcen' })}
        </Button>
      </div>
      <ul className="teamsHomeworkResourcesList">{selectedFilePickerResources}</ul>
    </div>
  );
};
